import { Fragment, useState } from "react";
import { ToolTip } from "../../../../../AbstractElements";
import { MailHeader } from "../../../../../Data/Applications/LetterBox/LetterBox";
import { useAppDispatch } from "../../../../../ReduxToolkit/Hooks";
import { handleInterview } from "../../../../../ReduxToolkit/Reducers/LetterBoxSlice";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";
import { InterviewMail } from "../../../../../Constants/Constants";

const InterviewMailHeader = () => {
  const dispatch = useAppDispatch();
  const [tooltipOpen, setTooltipOpen] = useState<number | null>(null);
  const toggle = (index: number) => setTooltipOpen(tooltipOpen !== index ? index : null);

  return (
    <div className="mail-header-wrapper header-wrapper1">
      <div className="mail-header1">
        <div className="light-square" onClick={() => dispatch(handleInterview(false))}>
          <SvgIcon className="btn-email" iconId="back-arrow" />
        </div>
        <span>{InterviewMail}</span>
      </div>
      <div className="mail-body1">
        {MailHeader.map((data, i) => (
          <Fragment key={i}>
            <div className={data.class} id={`light-${data.icon}`}>
              <SvgIcon iconId={data.icon} className={data.className ? data.className : ""} />
            </div>
            <ToolTip placement="top" isOpen={tooltipOpen === i} target={`light-${data.icon}`} toggle={() => toggle(i)}>
              {data.tooltip}
            </ToolTip>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default InterviewMailHeader;
